import Icon from '../components/Icon.vue'

Icon.register({
  'check-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504.5 171.9c10 10.1 10 26.4 0 36.4l-294.4 296.1c-10 10.1-26.2 10.1-36.2 0l-166.4-167.4c-10-10-10-26.4 0-36.4l36.2-36.4c10-10.1 26.2-10.1 36.2 0l112.1 112.7 240.1-241.5c10-10 26.2-10 36.2 0zM166.6 282.7l-122.6-123.5c-6.8-7-6.8-18.4 0.2-25.2l42.1-41.8c7-6.8 18.4-6.8 25.2 0.2l68.2 68.8 157.2-156.1c7-6.8 18.4-6.8 25.2 0.2l42 42.1c6.8 7 6.8 18.4-0.2 25.2l-212.1 210.3c-7 6.8-18.4 6.8-25.2-0.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/check-double.js
// module id = null
// module chunks = 